import ImageConversionPromise from './ImageConversionPromise';

const ProcessMap = {
  convertImageType:ImageConversionPromise
}

export default ProcessMap;
